document.addEventListener('DOMContentLoaded', () => {
  const builders = document.querySelectorAll('[data-pack-builder]');

  builders.forEach((builder) => {
    initArcosSchoolPackBuilder(builder);
  });
});


function initArcosSchoolPackBuilder(builder) {
  const productCards = builder.querySelectorAll('[data-pack-product]');

  const countElement = builder.querySelector('[data-pack-count]');
  const messageElement = builder.querySelector('[data-pack-message]');
  const nextMessageElement = builder.querySelector('[data-pack-next-message]');

  const subtotalElement = builder.querySelector('[data-pack-subtotal]');
  const discountRow = builder.querySelector('[data-pack-discount-row]');
  const discountLabel = builder.querySelector('[data-pack-discount-label]');
  const discountAmountElement = builder.querySelector('[data-pack-discount-amount]');
  const totalElement = builder.querySelector('[data-pack-total]');

  const selectedWrapper = builder.querySelector('[data-pack-selected-wrapper]');
  const selectedList = builder.querySelector('[data-pack-selected-list]');

  const addToCartButton = builder.querySelector('[data-pack-add-to-cart]');

  const tabs = builder.querySelectorAll('[data-pack-tab]');
  const panels = builder.querySelectorAll('[data-pack-panel]');

  const selectedProducts = new Map();


  /* ==========================================================
     PESTAÑAS
     ========================================================== */

  function activateTab(tabName) {
  tabs.forEach((tab) => {
    const isActive =
      tab.dataset.packTab === tabName;

    tab.classList.toggle(
      'is-active',
      isActive
    );

    tab.setAttribute(
      'aria-selected',
      isActive ? 'true' : 'false'
    );
  });


  panels.forEach((panel) => {
    const isActive =
      panel.dataset.packPanel === tabName;

    panel.classList.toggle(
      'is-active',
      isActive
    );

    panel.setAttribute(
      'aria-hidden',
      isActive ? 'false' : 'true'
    );

    panel.removeAttribute('hidden');
  });
}


  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      activateTab(
        tab.dataset.packTab
      );
    });
  });


  /* ==========================================================
     FORMATO DE PRECIO
     ========================================================== */

  function formatMoney(cents) {
    const currency =
      window.Shopify?.currency?.active || 'EUR';

    const locale =
      document.documentElement.lang || 'es-ES';

    return new Intl.NumberFormat(
      locale,
      {
        style: 'currency',
        currency
      }
    ).format(cents / 100);
  }


  /* ==========================================================
     TRAMOS
     ========================================================== */

  function getDiscountPercentage(quantity) {
    if (quantity >= 4) {
      return 20;
    }

    if (quantity === 3) {
      return 15;
    }

    return 10;
  }


  function getNextMessage(quantity) {
    if (quantity === 0) {
      return 'Añade 3 productos para conseguir un 15% de descuento.';
    }

    if (quantity === 1) {
      return 'Ya tienes un 10%. Añade 2 productos más para llegar al 15%.';
    }

    if (quantity === 2) {
      return 'Ya tienes un 10%. Añade 1 producto más para llegar al 15%.';
    }

    if (quantity === 3) {
      return 'Has conseguido un 15%. Añade 1 producto más para llegar al 20%.';
    }

    return 'Has alcanzado el descuento máximo del 20%.';
  }


  /* ==========================================================
     CARD
     ========================================================== */

  function updateCard(card) {
    const variantId =
      String(card.dataset.variantId);

    const selected =
      selectedProducts.get(variantId);

    const selectButton =
      card.querySelector('[data-pack-select]');

    const quantityControls =
      card.querySelector('[data-pack-quantity]');

    const quantityValue =
      card.querySelector('[data-pack-quantity-value]');

    const removeButton =
      card.querySelector('[data-pack-remove]');


    if (
      !selectButton ||
      !quantityControls ||
      !quantityValue ||
      !removeButton
    ) {
      return;
    }


    if (selected) {

      card.classList.add('is-selected');

      selectButton.hidden = true;
      quantityControls.hidden = false;
      removeButton.hidden = false;

      quantityValue.textContent =
        selected.quantity;

    } else {

      card.classList.remove('is-selected');

      selectButton.hidden = false;
      quantityControls.hidden = true;
      removeButton.hidden = true;

      quantityValue.textContent = '1';

    }
  }


  /* ==========================================================
     NIVELES
     ========================================================== */

  function updateLevels(quantity) {
    const levels =
      builder.querySelectorAll('[data-pack-level]');

    levels.forEach((level) => {
      const minimum =
        Number(level.dataset.packLevel);

      level.classList.toggle(
        'is-active',
        quantity >= minimum
      );
    });
  }


  /* ==========================================================
     PRODUCTOS AÑADIDOS EN EL RESUMEN
     ========================================================== */

  function updateSelectedProductsList() {
    if (
      !selectedWrapper ||
      !selectedList
    ) {
      return;
    }


    selectedList.innerHTML = '';


    if (selectedProducts.size === 0) {
      selectedWrapper.hidden = true;
      return;
    }


    selectedWrapper.hidden = false;


    selectedProducts.forEach((product) => {
      const item =
        document.createElement('li');

      item.className =
        'arcos-school__pack-selected-item';


      const name =
        document.createElement('span');

      name.className =
        'arcos-school__pack-selected-name';

      name.textContent =
        product.title;


      const quantity =
        document.createElement('span');

      quantity.className =
        'arcos-school__pack-selected-quantity';

      quantity.textContent =
        `×${product.quantity}`;


      item.appendChild(name);
      item.appendChild(quantity);

      selectedList.appendChild(item);
    });
  }


  /* ==========================================================
     RESUMEN
     ========================================================== */

  function updateSummary() {
    let totalQuantity = 0;
    let subtotal = 0;


    selectedProducts.forEach((product) => {
      totalQuantity +=
        product.quantity;

      subtotal +=
        product.price * product.quantity;
    });


    const discountPercentage =
      totalQuantity > 0
        ? getDiscountPercentage(totalQuantity)
        : 0;


    const discountAmount =
      Math.round(
        subtotal *
        (discountPercentage / 100)
      );


    const total =
      subtotal - discountAmount;


    if (countElement) {
      countElement.textContent =
        `${totalQuantity} ${
          totalQuantity === 1
            ? 'producto'
            : 'productos'
        }`;
    }


    if (messageElement) {

      if (discountPercentage > 0) {

        messageElement.textContent =
          `${discountPercentage}% de descuento conseguido`;

      } else {

        messageElement.textContent =
          'Elige tus productos';

      }
    }


    if (nextMessageElement) {
      nextMessageElement.textContent =
        getNextMessage(
          totalQuantity
        );
    }


    if (subtotalElement) {
      subtotalElement.textContent =
        formatMoney(subtotal);
    }


    if (totalElement) {
      totalElement.textContent =
        formatMoney(total);
    }


    if (
      discountRow &&
      discountLabel &&
      discountAmountElement
    ) {

      if (discountPercentage > 0) {

        discountRow.hidden = false;

        discountLabel.textContent =
          `-${discountPercentage}%`;

        discountAmountElement.textContent =
          `-${formatMoney(discountAmount)}`;

      } else {

        discountRow.hidden = true;

      }
    }


    updateLevels(totalQuantity);
    updateSelectedProductsList();


    if (addToCartButton) {
      addToCartButton.disabled =
        totalQuantity === 0;
    }
  }


  /* ==========================================================
     EVENTOS DE PRODUCTO
     ========================================================== */

  productCards.forEach((card) => {
    const variantId =
      String(card.dataset.variantId);

    const price =
      Number(
        card.dataset.productPrice || 0
      );

    const title =
      card.dataset.productTitle || '';

    const selectButton =
      card.querySelector('[data-pack-select]');

    const minusButton =
      card.querySelector('[data-pack-minus]');

    const plusButton =
      card.querySelector('[data-pack-plus]');

    const removeButton =
      card.querySelector('[data-pack-remove]');


    if (
      selectButton &&
      !selectButton.disabled
    ) {

      selectButton.addEventListener(
        'click',
        () => {

          selectedProducts.set(
            variantId,
            {
              variantId,
              title,
              price,
              quantity: 1
            }
          );

          updateCard(card);
          updateSummary();

        }
      );
    }


    if (plusButton) {

      plusButton.addEventListener(
        'click',
        () => {

          const product =
            selectedProducts.get(
              variantId
            );

          if (!product) {
            return;
          }

          product.quantity += 1;

          selectedProducts.set(
            variantId,
            product
          );

          updateCard(card);
          updateSummary();

        }
      );
    }


    if (minusButton) {

      minusButton.addEventListener(
        'click',
        () => {

          const product =
            selectedProducts.get(
              variantId
            );

          if (!product) {
            return;
          }


          if (product.quantity <= 1) {

            selectedProducts.delete(
              variantId
            );

          } else {

            product.quantity -= 1;

            selectedProducts.set(
              variantId,
              product
            );

          }


          updateCard(card);
          updateSummary();

        }
      );
    }


    if (removeButton) {

      removeButton.addEventListener(
        'click',
        () => {

          selectedProducts.delete(
            variantId
          );

          updateCard(card);
          updateSummary();

        }
      );
    }

  });


  /* ==========================================================
     AÑADIR PACK AL CARRITO
     ========================================================== */

  if (addToCartButton) {

    addToCartButton.addEventListener(
      'click',
      async () => {

        if (selectedProducts.size === 0) {
          return;
        }


        const buttonLabel =
          addToCartButton.querySelector('span');

        const originalText =
          buttonLabel
            ? buttonLabel.textContent
            : 'Añadir pack al carrito';


        addToCartButton.disabled = true;

        if (buttonLabel) {
          buttonLabel.textContent =
            'Añadiendo...';
        }


        const items =
          Array.from(
            selectedProducts.values()
          ).map((product) => {

            return {
              id: Number(product.variantId),
              quantity: product.quantity,
              properties: {
                '_Pack vuelta al cole': 'Sí'
              }
            };

          });


        try {

          const root =
            window.Shopify?.routes?.root || '/';


          const response =
            await fetch(
              `${root}cart/add.js`,
             {
                method: 'POST',

                headers: {
                  'Content-Type': 'application/json',
                  'Accept': 'application/json'
                },

                body: JSON.stringify({
                  items
                })
              }
            );


          if (!response.ok) {
            throw new Error(
              'No se ha podido añadir el pack al carrito.'
            );
          }


          /* ====================================================
             REFRESCAR CARRITO LATERAL Y CONTADOR
             ==================================================== */

          document.dispatchEvent(
            new CustomEvent('cart:refresh')
          );


          /*
            Damos un instante al theme para actualizar
            el contenido del cart drawer.
          */

          await new Promise((resolve) => {
            setTimeout(resolve, 250);
          });


          /* ====================================================
             ABRIR CARRITO LATERAL DEL THEME
             ==================================================== */

          const cartDrawerToggle =
            document.getElementById(
              'cart-drawer-toggle'
            );


          if (cartDrawerToggle) {

            cartDrawerToggle.click();

          } else {

            console.warn(
              '[Vuelta al cole] No se ha encontrado el botón del carrito lateral.'
            );

          }


        } catch (error) {

          console.error(
            '[Vuelta al cole] Error al añadir pack:',
            error
          );


          alert(
            'No se ha podido añadir el pack al carrito. Inténtalo de nuevo.'
          );


        } finally {

          addToCartButton.disabled = false;

          if (buttonLabel) {
            buttonLabel.textContent =
              originalText;
          }

        }

      }
    );
  }


  updateSummary();
}


/* ============================================================
   NAVEGACIÓN SUAVE DE LA FRANJA SUPERIOR
   ============================================================ */

document.addEventListener('click', (event) => {
  const link =
    event.target.closest(
      '.arcos-school__discounts a[href^="#"]'
    );

  if (!link) {
    return;
  }


  const targetId =
    link.getAttribute('href');

  if (
    !targetId ||
    targetId === '#'
  ) {
    return;
  }


  const target =
    document.querySelector(
      targetId
    );

  if (!target) {
    return;
  }


  event.preventDefault();


  const headerOffset = 100;

  const targetPosition =
    target.getBoundingClientRect().top +
    window.scrollY -
    headerOffset;


  window.scrollTo({
    top: targetPosition,
    behavior: 'smooth'
  });
});